import Report from '../../../model/Report'
import { addReport as apiAddReport, loadReportList } from '../../../rest-api/Report-api'
import { Dispatch } from 'redux'
import { actionCreatorFactory, AnyAction } from 'typescript-fsa'
import wrapAsyncWorker from '../../../common/wrapAsyncWorker'
import NewReport from '../../../model/NewReport'

const actionCreator = actionCreatorFactory()

export const AddReport = actionCreator.async<
  { market: string; reportGroup: string; report: NewReport },
  Report[],
  string
>('AddReport')

const addReportWorker = wrapAsyncWorker(
  AddReport,
  (params: { market: string; reportGroup: string; report: NewReport }): Promise<Report[]> =>
    apiAddReport(params).then(() =>
      loadReportList({ market: params.market, reportGroup: params.reportGroup })
    )
)

// thunk action creator
export const addReport = (market: string, reportGroup: string, report: NewReport) => {
  return (dispatch: Dispatch<AnyAction>) =>
    addReportWorker(dispatch, { market, reportGroup, report })
}
